<template>
  <div>
    <div class="upgrade-plan-container">
      <!-- Current Plan Section -->
      <div class="current-plan-section">
        <div class="current-plan-wrapper">
          <div class="plan-info-left">
            <span class="plan-label">Your Current Plan<span v-if="planFound">:</span></span>
            <span v-if="planFound && plan_details.plan_name" class="plan-name">{{ plan_details.plan_name }}</span>
          </div>
          <div class="plan-info-right">
            <span v-if="planFound && !planExpired && plan_details.expiry_date" class="plan-expiry">Expires on: {{ formatDate(plan_details.expiry_date) }}</span>
            <div v-else-if="planExpired" class="no-plan-badge">
              Your plan has expired
            </div>
            <div v-else-if="!planFound" class="no-plan-badge">
              No Active Any Plan
            </div>
          </div>
        </div>
      </div>

      <!-- Choose Plan Section -->
      <div class="choose-plan-section">
        <h2 class="section-title text-center">Choose Your Plan</h2>
        
        <!-- Cancel Plan Message -->
        <div v-if="cancel_plan" class="cancel-plan-message">
          <p>Your previous subscription has expired. Please cancel it to continue.</p>
        </div>
        
        <!-- Plan Cards -->
        <div class="pricing-plans" :class="{ 'many-plans': plan_list.length > 3 }">
          <div v-for="plan in plan_list" :key="plan._id" 
               class="pricing-plan-card" 
               :class="{ selected: selectedPlan && selectedPlan._id === plan._id }"
               @click="selectPlan(plan)">
            
            <!-- Current Plan Badge -->
            <div v-if="isCurrentPlan(plan)" class="current-plan-badge-gradient">Current Plan</div>
            
            <div class="plan-header">
              <p class="plan-name">{{ plan.plan_name }}</p>
              <div class="plan-price-gold">
                <span class="plan-original-price">${{ plan.price }}</span>
                <span class="plan-offer-price">${{ getOfferPrice(plan) }} / month</span>
              </div>
            </div>
            
            <ul class="plan-features">
              <li v-if="plan.plan_name.toLowerCase() === 'silver'">
                <span>Great for solopreneurs and hobbyists</span>
              </li>
              <li v-if="plan.plan_name.toLowerCase() === 'gold'">
                <span>For a small team who needs to collaborate</span>
              </li>
              <li v-if="plan.plan_name.toLowerCase() === 'platinum'">
                <span>For those who just need more.</span>
              </li>
              <li>
                <span>{{ plan.monitorcount }} monitors</span>
              </li>
              <li>
                <span>{{ plan.minIntervalLimit }} min. monitoring interval</span>
              </li>
              <li v-if="hasMonitorType(plan, [1, 3, 4])">
                <span>HTTP, port & ping monitor</span>
              </li>
              <li v-if="hasMonitorType(plan, [2])">
                <span>Keyword monitor</span>
              </li>
              <li v-if="hasMonitorType(plan, [5])">
                <span>Heartbeat monitor</span>
              </li>
              <li v-if="hasMonitorType(plan, [6])">
                <span>Page speed monitor</span>
              </li>
              <li v-if="hasMonitorType(plan, [7])">
                <span>Page screenshot monitor</span>
              </li>
              <li>
                <span>SSL monitor</span>
              </li>
              <li>
                <span>{{ getIntegrationsDisplay(plan) }}</span>
              </li>
              <li><span>Full featured status pages</span></li>
              <li>
                <span>{{ plan.subUserLimit }} Sub user{{ plan.subUserLimit !== 1 ? 's' : '' }} allowed</span>
              </li>
            </ul>
            
            <button 
              v-if="cancel_plan && selectedPlan && selectedPlan._id === plan._id"
              class="plan-button cancel-continue" 
              @click.stop="cancelAndContinue(plan)"
            >
              <span v-if="loading">Loading... </span>Cancel & Continue
            </button>
            <button 
              v-else
              class="plan-button" 
              @click.stop="handleUpgrade(plan)"
            >
              Upgrade Now
            </button>
          </div>
        </div>
        
        <!-- More Details Link -->
        <div class="more-details-section">
          <div class="more-details-wrapper">
            <span class="more-details-text">Why the Choose The Plan & more details</span>
            <a href="https://makeping.com/#pricing" target="_blank" rel="noopener noreferrer" class="more-details-link">Click here</a>
          </div>
        </div>
      </div>
      
      <!-- Cancel Subscription -->
      <div v-if="plan_details.plan_type != 1 && planFound && !planExpired" class="cancel-section">
        <button class="cancel-button" @click="cancelPlan()">
          <span v-if="loading">Loading... </span>Cancel Subscription
        </button>
      </div>
    </div>
  </div>
</template>




<script>
import UserController from "../../services/userController";
import { revenueEvents } from "../plugins/posthog-events";
export default {
  name: "UpgradePlan",
  data() {
    return {
      selectedPlan: null,
      planFound: true,
      planExpired: false,
      plan_details: {},
      plan_list: [],
      loading: false,
      cancel_plan: false,
      monitor_type_opt: {
        1: "HTTP(s)",
        2: "Keyword",
        3: "Ping",
        4: "Port",
        5: "Heartbeat",
        6: "Page Speed",
        7: "Page Screenshot",
      },
      alert_opt: {
        1: "Email",
        2: "Skype",
        3: "Telegram",
        4: "Web push",
        5: "Webhook",
        6: "Message",
        7: "Call",
        8: "Slack",
        9: "Zappier webhook",
        10: "Zulip",
        11: "Teams",
      },
    };
  },
  mounted() {
    this.getPlanInfo();
    this.GetPlansList();
  },
  methods: {
    isCurrentPlan(plan) {
      // Check if this plan matches the current user's plan (even if expired)
      if (!this.planFound || !this.plan_details.plan_name) {
        return false;
      }
      return plan.plan_name && plan.plan_name.toLowerCase() === this.plan_details.plan_name.toLowerCase();
    },
    async getPlanInfo() {
      let response = await UserController.getPlanInfo();
      if (response.result) {
        if(response.message == 'PLAN_NOT_FOUND'){
          this.planFound = false
        } else if(new Date(response.message.expiry_date) < new Date()) {
          this.planExpired = true
          this.plan_details = response.message;
        }else {
          this.plan_details = response.message;
        }
        
        // Emit plan status to parent
        this.$emit('plan-status', {
          planFound: this.planFound,
          planExpired: this.planExpired
        });
      }
    },
    async GetPlansList() {
      let response = await UserController.getPlanList();
      if (response.result) {
        // Sort plans to show in order: Silver, Gold, Platinum
        const planOrder = ['silver', 'gold', 'platinum'];
        this.plan_list = response.data.sort((a, b) => {
          const aIndex = planOrder.indexOf((a.plan_name || '').toLowerCase());
          const bIndex = planOrder.indexOf((b.plan_name || '').toLowerCase());
          
          // If both plans are in the order array, sort by their position
          if (aIndex !== -1 && bIndex !== -1) {
            return aIndex - bIndex;
          }
          // If only one is in the order array, prioritize it
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
          // Otherwise keep original order
          return 0;
        });
        
        // Select current plan if exists, otherwise default to middle plan (Gold)
        if (this.planFound && !this.planExpired && this.plan_details.plan_name) {
          const currentPlan = this.plan_list.find(p => 
            p.plan_name && p.plan_name.toLowerCase() === this.plan_details.plan_name.toLowerCase()
          );
          if (currentPlan) {
            this.selectedPlan = currentPlan;
            return;
          }
        }
        
        // Default to Gold (middle plan) if no current plan
        const goldPlan = this.plan_list.find(p => p.plan_name && p.plan_name.toLowerCase() === 'gold');
        if (goldPlan) {
          this.selectedPlan = goldPlan;
        }
      } else {
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
      }
    },
    selectPlan(plan) {
      this.selectedPlan = plan;
    },
    async handleUpgrade(plan) {
      this.selectedPlan = plan;
      const input = { plan_id: plan._id };

      // Track plan upgrade attempt in PostHog
      if (this.plan_details.plan_name) {
        revenueEvents.planUpgraded(
          this.plan_details.plan_name,
          plan.plan_name,
          plan.price
        );
      }

      let response = await UserController.checkOut(input);
      if (response.result) {
        window.location.replace(response.data);
      } else if (response.error_code) {
        // Backend indicates need to cancel subscription first
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        this.cancel_plan = true; // Set this to show Cancel & Continue button
      } else {
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
      }
    },
    async cancelPlan() {
      if (confirm("Are you sure you want to cancel your subscription?")) {
        this.loading = true;
        let response = await UserController.cancelSubcscription({});
        if (response.result) {
          // Track subscription cancellation in PostHog
          revenueEvents.subscriptionCancelled(
            this.plan_details.plan_name || 'unknown',
            'user_requested'
          );

          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 2000,
          });
          this.cancel_plan = false; // Reset the flag
          this.getPlanInfo();
        } else {
          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000,
          });
        }
        this.loading = false;
      }
    },
    async cancelAndContinue(plan) {
      this.loading = true;
      let response = await UserController.cancelSubcscription({});
      if (response.result) {
        this.$toasted.show("Subscription cancelled successfully", {
          theme: "outline",
          position: "bottom-center",
          type: "success",
          duration: 2000,
        });
        this.cancel_plan = false; // Reset the flag
        // Now proceed with checkout
        const input = { plan_id: plan._id };
        let checkoutResponse = await UserController.checkOut(input);
        if (checkoutResponse.result) {
          window.location.replace(checkoutResponse.data);
        } else {
          this.$toasted.show(checkoutResponse.message, {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000,
          });
        }
      } else {
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
      }
      this.loading = false;
    },
    getOfferPrice(plan) {
      if (!plan.discountValue || plan.discountValue === 0) {
        return plan.price ? plan.price.toFixed(2) : '0.00';
      }
      
      let discountAmount = 0;
      if (plan.discountType === 'fixed') {
        discountAmount = plan.discountValue;
      } else if (plan.discountType === 'percentage') {
        discountAmount = (plan.price * plan.discountValue) / 100;
      }
      
      const offerPrice = plan.price - discountAmount;
      return offerPrice > 0 ? offerPrice.toFixed(2) : '0.06';
    },
    getDiscountAmount(plan) {
      if (!plan.discountValue || plan.discountValue === 0) return '0.00';
      
      let discountAmount = 0;
      if (plan.discountType === 'fixed') {
        discountAmount = plan.discountValue;
      } else if (plan.discountType === 'percentage') {
        discountAmount = (plan.price * plan.discountValue) / 100;
      }
      
      return discountAmount.toFixed(2);
    },
    getMonitorTypesText(plan) {
      const allTypes = Object.keys(this.monitor_type_opt).map(Number);
      const types = plan.monitorTypes || [];
      
      if (types.length === 0) return '-';
      if (types.length === allTypes.length) return 'All';
      
      return types.map(t => this.monitor_type_opt[t] || t).join(', ');
    },
    getAlertsText(plan) {
      const allTypes = Object.keys(this.alert_opt).map(Number);
      const types = plan.alertsTypes || [];
      
      if (types.length === 0) return '-';
      if (types.length === allTypes.length) return 'All';
      
      return types.map(t => this.alert_opt[t] || t).join(', ');
    },
    getExcludedIntegrationsText(plan) {
      const allTypes = Object.keys(this.alert_opt).map(Number);
      const includedTypes = plan.alertsTypes || [];
      const excludedTypes = allTypes.filter(type => !includedTypes.includes(type));
      
      if (excludedTypes.length === 0) return 'None';
      if (includedTypes.length === 0) return 'All';
      
      return excludedTypes.map(t => this.alert_opt[t] || t).join(', ');
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    getIntegrationCount(plan) {
      const alertTypes = plan.alertsTypes || [];
      return alertTypes.length || 8;
    },
    hasMonitorType(plan, typeIds) {
      const types = plan.monitorTypes || [];
      return typeIds.some(id => types.includes(id));
    },
    getIntegrationsDisplay(plan) {
      const alertTypes = plan.alertsTypes || [];
      const totalIntegrations = 11; // Total integrations available
      
      if (alertTypes.length === 0) return 'No integrations';
      if (alertTypes.length === totalIntegrations) return 'All 11 integrations';
      
      return `Only ${alertTypes.length} integration${alertTypes.length !== 1 ? 's' : ''}`;
    },
  },
};
</script>


<style scoped>
.upgrade-plan-modal {
  font-family: Poppins;
  background-color: #f7f9fc;
  padding: 40px 20px;
  min-height: 600px;
}

.upgrade-plan-container {
  max-width: 1090px;
  margin: 0 auto;
}

.section-title {
  font-size: 30px;
  font-weight: 600;
  font-family: Poppins;
  margin-bottom: 20px;
}

/* Current Plan Section */
.current-plan-section {
  margin: 40px 0;
}

.current-plan-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 20px 30px;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
}

.plan-info-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.plan-label {
  font-size: 24px;
  font-weight: 600;
  font-family: Poppins;
  color: #3A3A3A;
}

.plan-name {
  font-size: 24px;
  font-weight: 600;
  font-family: Poppins;
  color: #0B6CFA;
}

.plan-info-right {
  display: flex;
  align-items: center;
}

.plan-expiry {
  font-size: 16px;
  color: #6b7280;
}

.no-plan-badge {
  display: inline-block;
  background: #fee2e2;
  color: #dc2626;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
}

/* Choose Plan Section */
.choose-plan-section {
  margin-bottom: 40px;
}

.pricing-plans {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 30px;
}

.pricing-plans.many-plans {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.pricing-plan-card {
  position: relative;
  background: #ffffff;
  border: 1px solid #d2e3fb;
  box-shadow: 0px 4px 20px #0b6cfa1a;
  border-radius: 16px;
  padding: 30px 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pricing-plan-card:hover {
  border-color: #0B6CFA;
  box-shadow: 0 8px 24px rgba(11, 108, 250, 0.15);
  transform: translateY(-2px);
}

.pricing-plan-card.selected {
  border-color: #0B6CFA;
  box-shadow: 0 8px 24px rgba(11, 108, 250, 0.2);
}

.current-plan-badge-gradient {
  position: absolute;
  top: 0;
  left: 0;
  padding: 4px 18px 4px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border-top-left-radius: 16px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  background: linear-gradient(90deg, #0B6CFA 60%, rgba(11,108,250,0) 100%);
  z-index: 2;
  box-shadow: none;
  letter-spacing: 0.5px;
  transition: none;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

.current-plan-badge-gradient:hover {
  background: linear-gradient(90deg, #0B6CFA 60%, rgba(11,108,250,0) 100%);
}

.plan-header {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.plan-header .plan-name {
  font-size: 24px;
  font-weight: 700;
  color: #0B6CFA;
  margin: 0 0 12px 0;
}

.plan-price {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
}

.price-currency {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.price-amount {
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1;
}

.price-period {
  font-size: 14px;
  color: #6b7280;
  margin-left: 8px;
}

.plan-features {
  list-style: disc inside;
  padding: 0;
  margin: 0 0 24px 0;
  flex: 1;
}

.plan-features li {
  padding: 8px 0 8px 18px;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
  background: none;
  position: relative;
}

.plan-features li:nth-child(even) {
  background: #F5F5F5;
  border-radius: 4px;
}

.plan-button {
  width: 100%;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  background-color: #0B6CFA;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.plan-button:hover:not(.disabled) {
  background-color: #0956d0;
}

.plan-button.disabled {
  background-color: #6B7280;
  cursor: not-allowed;
  opacity: 0.7;
}

.plan-button.disabled:hover {
  background-color: #6B7280;
}

.plan-button.cancel-continue {
  background-color: #DFBE00;
}

.plan-button.cancel-continue:hover {
  background-color: #c5a700;
}

/* Cancel Plan Message */
.cancel-plan-message {
  text-align: center;
  margin-bottom: 20px;
}

.cancel-plan-message p {
  color: #dc2626;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

/* More Details Section */
.more-details-section {
  margin-bottom: 40px;
}

.more-details-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 20px 30px;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
}

.more-details-text {
  font-size: 16px;
  color: #6b7280;
  font-family: Poppins;
}

.more-details-link {
  color: #0B6CFA;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  font-family: Poppins;
  transition: all 0.2s ease;
}

.more-details-link:hover {
  text-decoration: underline;
  color: #0956d0;
}

/* Cancel Section */
.cancel-section {
  text-align: center;
  padding-top: 20px;
}

.cancel-button {
  background: transparent;
  color: #dc2626;
  border: 2px solid #dc2626;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background: #dc2626;
  color: white;
}

/* Responsive */
@media (max-width: 1024px) {
  .pricing-plans {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .pricing-plans {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .current-plan-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .plan-info-left,
  .plan-info-right {
    width: 100%;
  }
  
  .plan-label,
  .plan-name {
    font-size: 18px;
  }
  
  .more-details-wrapper {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .more-details-text,
  .more-details-link {
    font-size: 14px;
  }
  
  .section-title {
    font-size: 20px;
  }
  
  .price-amount {
    font-size: 32px;
  }
}

@media (max-width: 480px) {
  .upgrade-plan-modal {
    padding: 20px 15px;
  }
  
  .pricing-plan-card {
    padding: 20px 16px;
  }
  
  .plan-header .plan-name {
    font-size: 20px;
  }
  
  .plan-features li {
    font-size: 13px;
  }
}

.plan-price {
  color: #0B6CFA;
  font-family: Poppins;
  font-size: 24px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 0;
}

.plan-original-price {
  font-size: 24px;
  font-weight: 700;
  color: #A3A3A3;
  text-decoration: line-through;
  margin-right: 6px;
}

.plan-offer-price {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  margin-right: 4px;
}

.plan-price-period {
  font-size: 22px;
  color: #444;
  font-weight: 400;
  margin-left: 2px;
}
</style>

<style>
.my-custom-toast {
  position: fixed !important;
  top: 90% !important;
  left: 20% !important;
}
</style>